var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"className":"stroke","transform":"translate(-718.000000, -2602.000000)","stroke":"#F2C1B6","strokeWidth":"2"},React.createElement("g",{"transform":"translate(720.000000, 2224.000000)"},React.createElement("g",{"transform":"translate(0.000000, 147.000000)"},React.createElement("g",{"transform":"translate(0.000000, 198.000000)"},React.createElement("g",{"transform":"translate(0.000000, 34.000000)"},React.createElement("polygon",{"points":"0 49.1398926 26.7180322 0.427246094 541 0.427246094 514.214481 21 535.642896 21 514.214481 49.1398926"}))))))));
}

Phone.defaultProps = {"preserveAspectRatio":"none","width":"546px","height":"52px","viewBox":"0 0 546 52","version":"1.1"};

module.exports = Phone;

Phone.default = Phone;
